import { render, staticRenderFns } from "./FacetPlot.vue?vue&type=template&id=5c1b0c5c&scoped=true&"
import script from "./FacetPlot.vue?vue&type=script&lang=js&"
export * from "./FacetPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b0c5c",
  null
  
)

export default component.exports